import { render, staticRenderFns } from "./PreConferenceStudyVisit2024.vue?vue&type=template&id=45d38811&scoped=true"
import script from "./PreConferenceStudyVisit2024.vue?vue&type=script&lang=js"
export * from "./PreConferenceStudyVisit2024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d38811",
  null
  
)

export default component.exports